import { useMemo } from 'react'

import { buildNavigationTree } from '@/helpers/buildNavigationTree'
import { useHeaderContext } from '@/hooks/useHeaderContext'
import { useIsLoggedIn } from '@/hooks/useIsLoggedIn'
import { useTranslations } from '@/hooks/useTranslations'

import type { SanityMenuItem } from '@/interfaces/SanityHeader'

const NO_MENU_ITEMS: SanityMenuItem[] = []

export const useNavigationTree = (menuItems: SanityMenuItem[] = NO_MENU_ITEMS) => {
  const { catalog } = useHeaderContext()
  const { language } = useTranslations()
  const isLoggedIn = useIsLoggedIn()

  return useMemo(
    () => buildNavigationTree(menuItems, { catalog, language, isLoggedIn }),
    [menuItems, catalog, language, isLoggedIn]
  )
}
